import ClientsMassiveUpload from './containers/ClientsMassiveUpload';

export default ClientsMassiveUpload;
